import { render } from "./PublicResourceManager.vue?vue&type=template&id=ff0879c8&scoped=true"
import script from "./PublicResourceManager.vue?vue&type=script&lang=js"
export * from "./PublicResourceManager.vue?vue&type=script&lang=js"

import "./PublicResourceManager.vue?vue&type=style&index=0&id=ff0879c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0879c8"]])

export default __exports__